<!--
 * @Author: your name
 * @Date: 2021-06-24 11:07:32
 * @LastEditTime: 2021-11-29 16:54:59
 * @LastEditors: your name
 * @Description: yang
 * @FilePath: \web_bank\src\App.vue
 * 可以输入预定的版权声明、个性签名、空行等
-->
<template>
  <div id="app">
   <div style="color:#cccccc;">
   </div>
    <router-view/>
  </div>
</template>
<script>
import {getAuthorizationCode,abcCode} from '@/api/http'
export default {
  name: 'home',
  components: {
   
  },
  data(){
    return{
        url:""
    }
  },
  methods:{
    
  },
  mounted(){
    // this.getAuthorizationCode()
    this.url = window.location.href
  }
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  /* -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; */
  /* text-align: center;
  color: #2c3e50; */
}

</style>
